<div class="border-m0 bg-m0 group h-full w-full rounded border shadow">
  <div class="mx-5 h-full">
    <div class="flex h-full w-full flex-col">
      <div
        class="text-s1 mb-5 mt-8 flex flex-shrink-0 flex-row items-start justify-center text-lg"
      >
        <div class="h-9 w-9 flex-shrink-0"></div>

        <div
          class="text-s1 hover:text-m500 ml-3 flex max-h-[60px] flex-grow cursor-pointer flex-col items-center justify-start"
          (click)="showChart()"
        >
          <div
            class="mt-[2px] line-clamp-2 flex max-h-[60px] select-none flex-col items-center text-center font-semibold"
          >
            {{ title }}
          </div>
        </div>

        <div class="relative ml-3 flex h-9 w-9 flex-shrink-0">
          <ngx-spinner
            [name]="tile?.title"
            color="#0084d1"
            bdColor="#00000000"
            size="default"
            type="ball-clip-rotate"
            [fullScreen]="false"
            [disableAnimation]="true"
            [zIndex]="10"
          >
          </ngx-spinner>
        </div>
      </div>

      <div
        *ngIf="showTileParameters === true && mconfig?.filters.length > 0"
        class="mx-0 mb-5 flex max-w-max flex-shrink-0 flex-row items-start overflow-auto"
      >
        <m-bricks
          class="flex max-h-[120px] max-w-max flex-shrink-0 flex-row"
          [extendedFilters]="mconfig.extendedFilters"
          [listen]="tile.listen"
          [tileTitle]="tile.title"
          [deleteFilterFn]="deleteFilterFn"
          [isKeepBackgroundColor]="false"
        ></m-bricks>
      </div>

      <div
        class="bg-m0 flex w-full flex-grow cursor-default overflow-auto rounded pb-10"
        [ngClass]="{
          'px-7': mconfig?.chart.type !== chartTypeEnumSingle
        }"
        (click)="stopClick($event)"
      >
        <m-chart-view
          #chartView
          *ngIf="!!qData && !!mconfig?.mconfigId"
          [ngClass]="{
            'pt-3':
              mconfig?.chart.type === chartTypeEnumTable ||
              mconfig?.chart.type === chartTypeEnumPivotTable,
            'max-w-max':
              (mconfig?.chart.type === chartTypeEnumTable ||
                mconfig?.chart.type === chartTypeEnumPivotTable) &&
              isSelectValid === true &&
              mconfig?.chart.isValid === true &&
              qData?.length > 0
          }"
          class="h-full w-full"
          [isTableHeaderWide]="false"
          [modelType]="mconfig.modelType"
          [mconfigFields]="mconfig.fields"
          [mconfigTimezone]="mconfig.timezone"
          [qData]="qData"
          [chart]="mconfig.chart"
          [isAnimation]="false"
          [isStoreModel]="mconfig?.modelType === modelTypeStore"
          [queryStatus]="query?.status"
          [chartInstanceId]="'dashboard-tile-mconfig-id-' + mconfig?.mconfigId"
        ></m-chart-view>
      </div>
    </div>
  </div>
</div>
<div class="text-m1 invisible cursor-default">{{ randomId }}</div>

<div *ngIf="nav$ | async"></div>
<!-- <div *ngIf="isExplorer$ | async"></div> -->
